<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import AddMeetingRoom from "./operate/addMeetingRoom.vue";

export default {
  extends: baseList,
  components: { AddMeetingRoom },
  data() {
    return {
      table: {
        mname: "",
        key: "id",
        url: {
          list: "/admin/system/meeting/room/list",
        },
        output: false,
      },
      query: {
        state: 1,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/MyMeeting/index",
        },
      ],
      menus: [
        {
          label: "会议室",
          name: "MeetingRoom",
          auth: "system/MeetingRoom/index",
        },
      ],
      filters: [
        /*  {
          label: "地址",
          name: "building",
          value: "",
          KeyEnter: this.search,
          type: "input",
        }, */
        {
          label: "名称",
          name: "meetingName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "名称",
          key: "meetingName",
          minWidth: 0,
          align: "left",
          tooltip: "true",
        },
        {
          title: "地址",
          key: "address",
          minWidth: 0,
          align: "left",
          tooltip: "true",
        },
        {
          title: "性质",
          key: "liableState",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.liableState == 1 ? "需要审核" : "无需审核";
            return <span>{text}</span>;
          },
        },
        {
          title: "负责人",
          key: "liablePersonName",
          width: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <div>
                  <Button
                    size="small"
                    onClick={() => this.delItem(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginRight: "10px",
                    }}
                  >
                    删除
                  </Button>
                  <Button
                    size="small"
                    onClick={() => this.toedit(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    编辑
                  </Button>
                </div>
              );
            },
          ],
        },
      ],
      selectList: [],
      selectItem: "",
    };
  },
  created() {},
  methods: {
    onCancel() {
      this.$Modal.remove();
      this.search();
    },
    toAdd() {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeetingRoom
                onOnCancel={() => {
                  this.onCancel();
                }}
                action="add"
              />
            </div>
          );
        },
      });
    },
    toedit(row) {
      this.$Modal.success({
        closable: true,
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <AddMeetingRoom
                onOnCancel={() => {
                  this.onCancel();
                }}
                actions="edit"
                ids={row.id}
              />
            </div>
          );
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(
        `/admin/system/meeting/room/${row.id}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          this.search();
        }, 100);
      }
    },
  },
};
</script>
<style scoped></style>
